module.exports = __webpack_public_path__ + "img/8.45df4f20.png";